export const StructureItemId = {
  HAMBURGER_FK_RESULT: '6fc545b9-69ae-4ef8-8960-f8d05c35e14e',
};
